import apiClient, { strapiApiUrl } from "@/api/api";

async function postProperty(data: any) {
  return apiClient.post(`${strapiApiUrl}/immobilies`, { data: data });
}

export default {
  postProperty
}
